import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { DEMO_TOKENS, DEMO_USER, IS_DEMO } from '../demo/config.js';

export interface SessionUser {
  id: string;
  name: string;
  email: string;
  phone: string;
  role: 'rider' | 'driver' | 'admin';
}

interface SessionState {
  user: SessionUser | null;
  accessToken: string | null;
  refreshToken: string | null;
  setSession: (input: { user: SessionUser; accessToken: string; refreshToken: string }) => void;
  setTokens: (tokens: { accessToken: string; refreshToken: string }) => void;
  clear: () => void;
}

const initial = IS_DEMO
  ? {
      user: DEMO_USER as SessionUser | null,
      accessToken: DEMO_TOKENS.accessToken as string | null,
      refreshToken: DEMO_TOKENS.refreshToken as string | null,
    }
  : { user: null as SessionUser | null, accessToken: null as string | null, refreshToken: null as string | null };

export const useSession = create<SessionState>()(
  persist(
    (set) => ({
      ...initial,
      setSession: ({ user, accessToken, refreshToken }) => set({ user, accessToken, refreshToken }),
      setTokens: ({ accessToken, refreshToken }) => set({ accessToken, refreshToken }),
      clear: () => set(IS_DEMO ? initial : { user: null, accessToken: null, refreshToken: null }),
    }),
    { name: 'raahi-admin-session', version: IS_DEMO ? 2 : 1 },
  ),
);
